import i18next from 'i18next';
import pt from './translations/pt-br/translations.json';
import en from './translations/en/translations.json';
import es from './translations/es/translations.json';

export const LANGUAGE_STORAGE_KEY = 'userLanguagePreference';
// Define available languages
export const languages = [
  { code: 'PT', name: 'Português' },
  { code: 'EN', name: 'English' },
  { code: 'ES', name: 'Español' },
];

export const cultureHash = {
  pt: 'PT',
  en: 'EN',
  es: 'ES',
};

export const getSavedLanguage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const cultureParam = urlParams.get('culture')?.split('-')[0].toLowerCase();
  if (cultureParam) {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, cultureHash[cultureParam] ?? 'PT');
    return cultureHash[cultureParam]?.toLowerCase() || 'pt';
  }
  return localStorage.getItem(LANGUAGE_STORAGE_KEY)?.toLowerCase() || 'pt';
};

i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: getSavedLanguage(), // language to use
  resources: {
    pt,
    en,
    es,
  },
});

export default i18next;
